import {Component, Input} from "@angular/core";
import {BIAttribute} from "../../draggable-attributes-list/bi-attribute";


@Component({
    selector: "wbo-bi-draggable-item",
    templateUrl: "./draggable-item.component.html",
    styleUrls: ["./draggable-item.component.scss"]

})
export class DraggableItemComponent {

    @Input() label: string;

    @Input() icon: string;

    @Input() dropZones: string[];

    /**
     * Data to give the drop area
     */
    @Input() data: BIAttribute;

}
